function getCamelCaseArray(camel) {
    var reg = /([a-z0-9])([A-Z])/g;
    return camel.replace(reg, '$1 $2').split(' ');
}

export function splitCamelCaseToWords(value) {
    const array = getCamelCaseArray(value);
    let res = '';
    for (var i = 0; i < array.length; i++){
        res += array[i];
        if (i !== array.length - 1){
            res += ' ';
        }
    }
    return res;
}




// WEBPACK FOOTER //
// ./src/util/strings.js